import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomFieldSearchQuery } from '@/common/queries/useGetCustomFieldsQuery';
import {
  getSelectableFields,
  isHeaderDate,
} from '@/features/visualizations/components/layout/header-menu/utils';
import type { ColorContextData } from './types';

export function useColorLegendPopover(context: ColorContextData) {
  const { t } = useTranslation();

  const { currentColorByField, colorItems } = context;

  const { data: customFields } = useGetCustomFieldSearchQuery({ search: '' });
  const selectableFields = useMemo(
    () =>
      getSelectableFields({
        fields: customFields ?? [],
        t,
        includeItemDate: false,
        allowCustomFields: true,
        excludeMultiValueFields: true,
      }),
    [customFields, t],
  );
  const colorByFieldOptions = useMemo(
    () => selectableFields.filter((field) => !isHeaderDate(field.value)),
    [selectableFields],
  );

  const colorByFieldLabel = useMemo(() => {
    const option = colorByFieldOptions.find((opt) => opt.value === currentColorByField);
    return option?.label ?? currentColorByField ?? '';
  }, [colorByFieldOptions, currentColorByField]);

  const legendItems = colorItems;

  const shouldRender = Boolean(currentColorByField) && legendItems.length > 0;

  return { legendItems, colorByFieldLabel, shouldRender };
}
